import { GET_UPGRADESTATUS } from '~/constants/APIs'
import { IUpgradeStatus } from '~/models'
import axiosClient from './axiosClient'

export const upgradestatusApi = {
  getAll: () => axiosClient.get(GET_UPGRADESTATUS) as unknown as IUpgradeStatus
}
